var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('viewer',{class:("form-element form-" + _vm.type + "-element text-left"),attrs:{"initial-value":_vm.options.text}})}
var staticRenderFns = []

export { render, staticRenderFns }